import React, { Dispatch, useRef, useState } from 'react'
import { CloseIcon, IconActiveNotification, IconTestNotification } from '../iconSet/IconSet'
import { MobileNodeTypes } from './MobileDataTable'

export type ButtonsType = "TEST" | "ACTIVE"

type MobileNotificationPopupPropsType = {
    addTestFunction: (selectedData: MobileNodeTypes[]) => void
    addActiveFunction: (selectedData: MobileNodeTypes[]) => void
    setState: Dispatch<React.SetStateAction<boolean>>
}

const MobileNotificationPopup = (props: MobileNotificationPopupPropsType) => {

    let buttonStateRef = useRef<ButtonsType>("TEST") 
    const [buttonStatus, setButtonStatus] = useState<ButtonsType>("TEST")

    const handleOnClickButton = (state: ButtonsType) => {
        setButtonStatus(state)
        buttonStateRef.current = state
    }

    const handleAddClickButton = () => {
        if (buttonStateRef.current === "TEST")
        {
            props.addTestFunction([{id: "test-mobile-id-1", name: "M.Application - Test"}])
        }
        else if (buttonStateRef.current === "ACTIVE")
        {
            props.addActiveFunction([{id: "active-mobile-id-1", name: "M.Application - Active"}])
        }
    }

    return (
        <div className='mobile-notification-popup'>
            <div className='mobile-notification-popup-wrapper'>
                <span className='title'>Select mobile notification type
                    <CloseIcon width="1.2rem" color="var(--color-main-red)" onClick={() => props.setState(false)} />
                </span>
                
                <div className='popup-wrapper'>
                    <div className='select-button' onClick={(e) => handleOnClickButton("TEST")} style={{ borderBlockWidth: buttonStatus === "TEST" ? "0.3rem" : "0.1rem" }}>
                        <IconTestNotification width="1.3rem" color="var(--color-text)"/>
                        <span>Test</span>
                    </div>
                    <div className='select-button' onClick={(e) => handleOnClickButton("ACTIVE")} style={{ borderBlockWidth: buttonStatus === "ACTIVE" ? "0.3rem" : "0.1rem" }}>
                        <IconActiveNotification width="1.3rem" color="var(--color-text)"/>
                        <span>Active</span>
                    </div>
                </div>
                <div className='button-wrapper'>
                    <button onClick={(e) => handleAddClickButton()}>Add</button>
                </div>
            </div>
        </div>
    )
}

export default MobileNotificationPopup